module.exports = __webpack_public_path__ + "static/media/datepicker-prev-nav.7a2f3f59.svg";